import _ from 'lodash';
import { takeEvery, call, put, select, all } from 'redux-saga/effects';
import { gtagEvent } from '../../../../../utils/Analytics';
import {
  sendForm,
  requestRecoveryForm,
  recoveryFormFields,
  setErrors,
  clearAllErrors,
  validate,
  setSendFormResponse,
  finishedSendRequest,
  finishedRecoveryRequest
} from './actions';
import { selectFormBody, selectAllErrors } from './selectors';
import { timeoutCall } from '../../../../../utils/sagaHalper';
import TasksService from '../../../services/TasksService';
import { sendGetAuthAccountDataRequest } from '../../../../users/common/reducers/states/authAccount';

function* requestRecoveryFormSaga(reducerName, action) {
  try {
    yield put(clearAllErrors(reducerName));
    const result = yield call(
      timeoutCall,
      TasksService.getTaskForUpdate,
      action.payload.id
    );
    if (result.response.status === 200) {
      yield put(recoveryFormFields(reducerName, result.destructData));
    }
    yield put(
      finishedRecoveryRequest(
        reducerName,
        result.response.status,
        result.response.status === 200
      )
    );
  } catch (error) {
    console.log(error);
  }
  yield put(finishedRecoveryRequest(reducerName));
}

function* saveTask(reducerName, action) {
  yield put(clearAllErrors(reducerName));
  yield put(validate(reducerName));
  const allErrors = yield select(selectAllErrors, reducerName);
  if (_.isEmpty(allErrors)) {
    const formBody = yield select(selectFormBody, reducerName);
    try {
      const result = _.get(action, 'payload.id')
        ? yield call(
            timeoutCall,
            TasksService.updateTask,
            _.get(action, 'payload.id'),
            formBody
          )
        : yield call(timeoutCall, TasksService.createTask, formBody);
      if (result.response) {
        if (result.response.status === 422) {
          yield put(setErrors(reducerName, result.destructData));
        } else if (
          result.response.status === 201 ||
          result.response.status === 200
        ) {
          if (result.response.status === 201) {
            gtagEvent({
              action: 'Успешное создание задания',
              category: 'Создание задания',
              label: '',
              value: '0'
            });
          }
          yield put(setSendFormResponse(reducerName, result.destructData));
          yield put(sendGetAuthAccountDataRequest());
        }
        yield put(
          finishedSendRequest(
            reducerName,
            result.response.status,
            result.response.status === 201 || result.response.status === 200
          )
        );
      }
    } catch (error) {
      console.log(error);
    }
  }
  yield put(finishedSendRequest(reducerName));
}

export default function* createSaga(reducerName) {
  yield all([
    takeEvery(sendForm(reducerName).type, saveTask, reducerName),
    takeEvery(
      requestRecoveryForm(reducerName).type,
      requestRecoveryFormSaga,
      reducerName
    )
  ]);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/reducers/dynamic/taskFrom/saga.js